import React from 'react';
import {apis} from './variables/postmanApis';
import { Link } from 'react-router-dom';
import CashFlowIcon from '../../../assets/img/ops/cash-flow.png';
import EasySplit from '../../../assets/img/ops/money_10384161.png';

const Ops = () => {
    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="px-3 mt-20">
        <div className="grid grid-cols-1 md:lg:xl:grid-cols-3 group rounded-[20px] bg-white bg-clip-border shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none bg-white w-full rounded-3xl text-center">
            {
                apis.map(api => {
                    if(api) {
                        return (
                            <Link key={`item${api.id}`} to={`/admin/ops/${api.id}`}>
                            <div
                                className="p-10 flex flex-col items-center text-center group md:lg:xl:border-r md:lg:xl:border-b hover:bg-slate-50 cursor-pointer">
                                <div className="flex h-[90px] w-auto flex-row items-center">
                                    <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
                                    <span className="flex items-center text-brand-500 dark:text-white">
                                    <img src={api.icon} alt={api.name} className="h-12 w-12" />
                                    </span>
                                    </div>
                                </div>
                                <p className="text-base font-medium text-slate-700">{api.name}</p>
                            </div>
                            </Link>
                        );
                    }
                    return <div className="p-6 flex flex-col items-center text-center group md:lg:xl:border-r md:lg:xl:border-b hover:bg-slate-50" />;
                })
            }
            <Link key={`easysplit`} to={`/admin/ops/easysplit`}>
                <div
                    className="p-10 flex flex-col items-center text-center group md:lg:xl:border-r md:lg:xl:border-b hover:bg-slate-50 cursor-pointer">
                    <div className="flex h-[90px] w-auto flex-row items-center">
                        <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
                            <span className="flex items-center text-brand-500 dark:text-white">
                                <img src={EasySplit} alt='Automated Payout' className="h-12 w-12" />
                            </span>
                        </div>
                    </div>
                    <p className="text-base font-medium text-slate-700">{'Easy Split'}</p>
                </div>
            </Link>
            <Link key={`payout`} to={`/admin/ops/payout`}>
                <div
                    className="p-10 flex flex-col items-center text-center group md:lg:xl:border-r md:lg:xl:border-b hover:bg-slate-50 cursor-pointer">
                    <div className="flex h-[90px] w-auto flex-row items-center">
                        <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
                            <span className="flex items-center text-brand-500 dark:text-white">
                                <img src={CashFlowIcon} alt='Automated Payout' className="h-12 w-12" />
                            </span>
                        </div>
                    </div>
                    <p className="text-base font-medium text-slate-700">{'Automated Payouts'}</p>
                </div>
            </Link>
        </div>
    </div>
    )
}

export default Ops;